import { HTTP_STATUS } from '../http/constants/http.status';

export const getFailureMessage = (response: any): string => {
  let msg = '';
  const { status, data, statusText = '' } = response;
  if (status >= HTTP_STATUS.HTTP_BAD_REQUEST) {
    msg = [HTTP_STATUS.HTTP_NOT_FOUND, HTTP_STATUS.HTTP_REQUEST_URI_TOO_LONG].includes(status)
      ? statusText
      : data?.issues?.map((issue: any) => issue.details).join() || data || statusText || '';
  }
  return msg;
};
